package org.hs_soft.runmynesto.pages.home.mvi

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model.ChatMessageHistoryModel
import org.hs_soft.runmynesto.domain.model.menu.MenuItemsEnum

sealed class HomeEvent {

    data class SearchGlobally(val searchValue: String):HomeEvent()

    data class SetTabsClickableStatus(val status:Boolean):HomeEvent()

    data object DeleteCache:HomeEvent()

    data object DismissAllDialogs:HomeEvent()

    data object GetOptionData:HomeEvent()

    data object  GetHSSoftApps:HomeEvent()

    data object UserProfileInfo:HomeEvent()

    data object SignOut:HomeEvent()

    data object GetCheckoutData: HomeEvent()

    data object CloseMenu:HomeEvent()


    data object ChangeMenuStatus:HomeEvent()

    data object FetchIdToken :HomeEvent()

    data class OnChangeName(val value:String): HomeEvent()

    data class OnMenuItemClick(val menuItem:MenuItemsEnum):HomeEvent()

    data object ChangeShowingSearchBarInMobileStatus:HomeEvent()

    data object OnToolbarSettingIconClick:HomeEvent()

    data object OnToolbarApplicationsMenuIconClick :HomeEvent()

    data class InitWindowsSize(val windowsSize: WindowSizeModel) :HomeEvent()

    data object GetShopList:HomeEvent()

    data class OnChangeAIDataAssistantQuestion(
        val value:String
    ): HomeEvent()

    data class SetDataAssistantDialogStatus(
        val email: String,
        val status:Boolean
    ):HomeEvent()

    data class SetUserFavoriteMessagesStatus(
        val status:Boolean
    ):HomeEvent()

    data class SetInfoStatus(
        val status:Boolean
    ):HomeEvent()

    data class SetInputBarStatus(
        val status:Boolean
    ):HomeEvent()

    data class SetMoreStatus(
        val status:Boolean
    ):HomeEvent()

    data class SetDataAssistantIconStatus(
        val status:Boolean
    ):HomeEvent()

    data class GenerateDataAssistantAnswer(
        val email:String,
        val question:String,
        val messageHistory: ChatMessageHistoryModel,
        val logLanguage:String?,
        val userName:String,
        val userEmail:String,
        val userCompanyName:String
    ):HomeEvent()

    data class SaveDataAssistantFavoriteMessages(
        val email:String,
        val messageHistory: ChatMessageHistoryModel,
        val favoriteMessages: List<String>
    ):HomeEvent()

    data class GetDataAssistantMessageHistory(
        val email: String
    ):HomeEvent()

    data object GetVirtualCardInfo: HomeEvent()



}